import { styled } from 'baseui'
import type { Theme } from 'baseui'

interface ThemeProps {
  $theme: Theme
}

export const PulseResultBox = styled('div', ({ $theme }: ThemeProps) => ({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: '12px',
  paddingTop: '6px',
  paddingBottom: '6px',
  paddingLeft: '12px',
  paddingRight: '12px',
  borderTopLeftRadius: '10px',
  borderTopRightRadius: '10px',
  borderBottomLeftRadius: '10px',
  borderBottomRightRadius: '10px',
  borderTopWidth: '1px',
  borderBottomWidth: '1px',
  borderLeftWidth: '1px',
  borderRightWidth: '1px',
  borderTopStyle: 'solid',
  borderBottomStyle: 'solid',
  borderLeftStyle: 'solid',
  borderRightStyle: 'solid',
  borderTopColor: $theme.colors.borderPulse,
  borderBottomColor: $theme.colors.borderPulse,
  borderLeftColor: $theme.colors.borderPulse,
  borderRightColor: $theme.colors.borderPulse,
  backgroundColor: $theme.colors.bgPulseCanvas,
}))

export const PulseResultRow = styled('div', ({ $theme }: ThemeProps) => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: '12px',
  paddingTop: '4px',
  paddingBottom: '4px',
  fontSize: '13px',
  lineHeight: '18px',
  color: $theme.colors.textPulseMuted,
  ':not(:first-child)': {
    borderTopWidth: '1px',
    borderTopStyle: 'solid',
    borderTopColor: $theme.colors.bgPulseTabs,
  },
}))

export const PulseResultValue = styled('span', ({ $theme }: ThemeProps) => ({
  fontWeight: 600,
  textAlign: 'right',
  color: $theme.colors.textPulseStrong,
}))
